export default "__VITE_ASSET__D5nkXtWl__"